export default function Container({ children, className = '' }) {
  return (
    <div className={`container mx-auto px-6 md:px-8 lg:px-12 ${className}`}>
      {children}
    </div>
  );
}
